import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import { Check } from "@/components/Icon";
import heroImg from "@/assets/hero/dtf.webp";
import dtfPrinter from "@/assets/dtf/dtf-printer.webp";
import dtfTransfers from "@/assets/dtf/dtf-transfers.webp";
import dtfDetail from "@/assets/dtf/dtf-transfer-detail.webp";
import dtfProcess from "@/assets/dtf/dtf-process.webp";

const DtfPrinting = () => (
  <PageLayout
    title="DTF Printing"
    metaDescription="DTF Printing (Direct To Film) bij Magic Print Den Haag. Full color bedrukking op bijna alle stoffen. Milieuvriendelijk, wasbaar tot 40°C, vanaf 10 stuks."
    ogImage={heroImg}
    hero={
      <PageHero
        image={heroImg}
        alt="DTF Printing bij Magic Print"
        title="DTF Transfers"
        subtitle="Full color bedrukking, milieuvriendelijk en al leverbaar vanaf 10 stuks."
      />
    }
  >


    <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
      Het proces van DTF Printing (Direct To Film Printing) houdt in dat een afbeelding eerst in full color op een transparante ondergrond wordt geprint, ook wel genaamd een transfer. De DTF transfer wordt daarna met een hittepers op het textiel geperst.
    </p>
    <p className="text-muted-foreground mb-8">
      Deze nieuwe manier van textiel bedrukken heeft grote voordelen: het is milieuvriendelijk en kan al geleverd worden vanaf 10 stuks. Magic Print kan hierdoor een goed totaalproduct leveren.
    </p>

    <section className="mb-12 grid md:grid-cols-3 gap-4">
      <img src={dtfPrinter} alt="DTF printer Magic Print" loading="lazy" className="w-full h-auto rounded-2xl" />
      <img src={dtfTransfers} alt="DTF transfers" loading="lazy" className="w-full h-auto rounded-2xl" />
      <img src={dtfDetail} alt="DTF transfer detail" loading="lazy" className="w-full h-auto rounded-2xl" />
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Het bedrukken van stoffen</h2>
      <p className="text-muted-foreground mb-4">
        Er kan praktisch op bijna alle stoffen gedrukt worden, hier een aantal voorbeelden:
      </p>
      <ul className="grid grid-cols-2 gap-2 mb-4">
        {["Katoen", "Polyester", "Gemengde weefsels", "Nylon", "Leer", "Viscose"].map((s) => (
          <li key={s} className="flex items-center gap-2 text-muted-foreground">
            <Check className="w-4 h-4 text-primary shrink-0" />
            {s}
          </li>
        ))}
      </ul>
      <p className="text-muted-foreground mb-4">
        Over het algemeen zou je kunnen zeggen dat DTF Transfer bedrukkingen op bijna alles toepasbaar is. Een van de verschillende voordelen is dat het erg rekbaar is en vele malen gewassen kan worden (wij hebben het getest tot 60 keer wassen op 40°C graden).
      </p>
      <p className="text-muted-foreground">
        Na 60 wasbeurten is er nauwelijks verschil te zien ten opzichte van de eerste wasbeurt. De prints blijven dus van topkwaliteit. Waar wel rekening mee gehouden moet worden is dat er niet over de prints gestreken kan worden of gedroogd wordt in de wasdroger.
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Levertijden</h2>
      <p className="text-muted-foreground">
        De levertijden zijn met deze techniek ook sneller omdat het maken van deze bedrukkingen aanzienlijk sneller gaat dan de andere technieken. Wat wij zelf erg belangrijk vinden is dat de inkten op waterbasis zijn en daardoor milieuvriendelijk zijn. Tezamen met onze Eco lijn van kleding kunnen wij tegen lage prijzen milieuvriendelijke kleding bedrukt met milieuvriendelijke inkten aanbieden!
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">DTF Printing in combinatie met duurzaamheid en Fairtrade textiel</h2>
      <p className="text-muted-foreground">
        Duurzaamheid en Fairtrade textiel willen wij steeds meer gaan aanbieden om zo het milieu te ontzien. Op dit moment bieden wij die combinatie aan voor dezelfde prijzen als normaal niet ecologisch textiel bedrukt met normale inkten. Wij kunnen tot 40×50 cm bedrukken met deze nieuwe techniek, enkele kleuren tot full color afbeeldingen en foto's — alles is mogelijk en op vele soorten textiel.
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Hoe werkt DTF Printing?</h2>
      <p className="text-muted-foreground">
        In de textieldrukkerij van Magic Print wordt ervoor gezorgd dat de afbeelding het juiste formaat krijgt zoals de opdruk op het desbetreffende textiel moet worden geprint. Met DTF Printing kan er bijvoorbeeld gedrukt worden op T-shirts, polo's, sweaters en hoodies. Zodra de afbeelding het juiste formaat heeft wordt het bestand naar de printer verstuurd. Hierna wordt het bestand uitgeprint op een zgn Petfilm. Deze Petfilm wordt daarna door een bak met granulaatpoeder getransporteerd en de bedrukte film inclusief de poeder gaat door een droger. De laatste stap van het proces is dat de transfer wordt aangebracht door een warmtepers. Het hele proces is milieuvriendelijk — zowel de inkten als de Petfilm.
      </p>
    </section>

    <section className="mb-12 grid md:grid-cols-2 gap-8 items-center">
      <div>
        <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">De voordelen van DTF Printing</h2>
        <ul className="space-y-3">
          {[
            "Mogelijk op zowel wit als donker textiel",
            "Wasbaar tot 40°C graden",
            "Lage prijs in verhouding met full color zeefdruk",
            "Al vanaf 10 stuks leverbaar",
            "Milieuvriendelijk",
          ].map((v) => (
            <li key={v} className="flex items-center gap-2 text-muted-foreground">
              <Check className="w-4 h-4 text-primary shrink-0" />
              {v}
            </li>
          ))}
        </ul>
      </div>
      <img src={dtfProcess} alt="DTF printing proces" loading="lazy" className="w-full h-auto rounded-2xl" />
    </section>
  </PageLayout>
);

export default DtfPrinting;
